<template>
  <div>
    <div class="checklist-box mb-5">
      <div class="text-white checklist-title" style="">
        <div class="h4 mb-0 py-2 text-center">
          <span class="text-capitalize">{{ firstName }}</span>, Let's Get You Set Up.
        </div>
      </div>
      <div class="px-3 py-2" style="background-color: #f2fbfe;">
        <div class="row py-0 mb-2 step-row" v-for="(course, cindex) in courses" :key="'course_' + cindex">
          <div class="col-10 h6 mb-0 px-0 position-relative">
            <div class="rounded-circle bg-white step-circle">{{ cindex + 1 }}</div>
            <div class="step-line"></div>
            <div class="step-text">{{ course.title }}</div>
          </div>
          <div class="col-2 h6 mb-0 pl-0 pr-2 mt-2">
            <a v-if="course.certification_download_link" href="#" class="branding_text_color" @click.prevent="viewCourseReport(course.certification_download_link)" >View Certificate</a>
            <a v-else href="#" class="branding_text_color" @click.prevent="goToCourseLanding(course.lmsCourseId, course.lmsUserId)" >{{getCourseBtnName(course.certification_download_link, course.courseStatus)}}</a>
          </div>
        </div>

        <div class="row py-0 mb-2 step-row" v-for="(assessment, aindex) in assessments" :key="'assessment_' + aindex">
          <div class="col-10 h6 mb-0 px-0 position-relative">
            <div class="rounded-circle bg-white step-circle">{{ courses.length + aindex + 1 }}</div>
            <div class="step-line"></div>
            <div class="step-text">{{ assessment.title }}</div>
          </div>
          <div class="col-2 h6 mb-0 pl-0 pr-2 mt-2">
            <a v-if="assessment.complete_attempt_id" href="#" class="branding_text_color" @click.prevent="viewReport(assessment.complete_attempt_id)">View Result</a>
            <a v-else href="#" class="branding_text_color" @click.prevent="goToAssessmentLanding(assessment.id, assessment.inprogress_attempt_id)" >Start</a>
          </div>
        </div>

      </div>
    </div>

    <MenteeAssessmentLandingPage 
      :isModalVisible="isAssessmentLandingVisible"
      @closeAssessmentLandingModal="closeAssessmentLandingModal"
      @openAssessmentQuestionModal="openAssessmentQuestionModal"
      ref="MenteeAssessmentLandingModal">
    </MenteeAssessmentLandingPage>

    <MenteeAssessmentQuestionPage 
      :isModalVisible="isAssessmentQuestionVisible"
      @closeAssessmentQuestionModal="closeAssessmentQuestionModal"
      ref="MenteeAssessmentQuestionModal">
    </MenteeAssessmentQuestionPage>

    <MenteeFillForm 
      :isModalVisible="isMenteeFillFormVisible"
      @closeMenteeFillFormModal="closeMenteeFillFormModal"
      ref="MenteeFillFormModal">
    </MenteeFillForm>

    <MenteeEditForm 
      :isModalVisible="isMenteeEditFormVisible"
      @closeMenteeEditFormModal="closeMenteeEditFormModal"
      ref="MenteeEditFormModal">
    </MenteeEditForm>
  </div>
</template>

<script>
import axios from 'axios';
import router from '../../router/index.js';
import MenteeAssessmentLandingPage from '@/components/mentee/mentee_assessment_landing_new.vue';
import MenteeAssessmentQuestionPage from '@/components/mentee/mentee_assessment_question_new.vue';
import MenteeFillForm from '@/components/mentee/mentee_fill_form_new.vue';
import MenteeEditForm from '@/components/mentee/mentee_update_form_new.vue';

export default {
  components: {
    MenteeAssessmentLandingPage,
    MenteeAssessmentQuestionPage,
    MenteeFillForm,
    MenteeEditForm,
  },
  data() {
    return {
      firstName: '',
      courses: [],
      assessments: [],
      isAssessmentLandingVisible: false,
      isAssessmentQuestionVisible: false,
      forms: [],
      isMenteeFillFormVisible: false,
      isMenteeEditFormVisible: false,
    }
  },
  computed: {
    
  },
  methods: {
    openAddMentorModal() {
      this.$emit('openAddMentorModal', 'mentor');
    },
    getCoursesData() {
      axios.get('/desktop/manager-checklist/course-lists/' + this.$store.state.user_accountid, {
      })
        .then(response => {
          this.courses = response.data.course;
        })
        .catch(function () {});
    },
    getAssessmentsData() {
      axios.get('/desktop/checklist-manager/assessment-lists/' + this.$store.state.user_accountid, {
      })
      .then(response =>  {
        this.assessments = response.data.assessment;
      })
      .catch(function() {});
    },
    setUpData() {
      this.firstName = this.$store.state.first_name;
      this.getCoursesData();
      this.getAssessmentsData();
      this.getReloadForms();
    },
    getCourseBtnName(certificate, courseStatus) {
      var res = 'Begin';
      if (certificate) {
        res = 'Re-Take';
      }
      else if (courseStatus == 1) {
        res = 'Continue';
      }
      return res;
    },
    viewCourseReport: function (url) {
      window.open(url, '_blank');
    },
    goToCourseLanding(courseId, lmsUserId) {
      var dashboardPath = this.$route.fullPath;
      dashboardPath = dashboardPath.replace(/^\/+/,"");
     
      router.push('/take-course/'+ lmsUserId + '/' + dashboardPath + '?c=' + courseId);
    },
    viewReport: function (id) {
      let routeData = this.$router.resolve({ name: 'assessmentreportnew', params: { assessmentAttemptId: id } });
      window.open(routeData.href, '_blank');
    },
    closeAssessmentLandingModal() {
      this.isAssessmentLandingVisible = false;
    },
    openAssessmentQuestionModal(assessmentId, assessmentAttemptId) {
      this.$refs.MenteeAssessmentQuestionModal.getScaleLists(assessmentId, assessmentAttemptId);
      this.isAssessmentLandingVisible = false;
      this.isAssessmentQuestionVisible = true;
    },
    closeAssessmentQuestionModal () {
      this.isAssessmentQuestionVisible = false;
    },
    goToAssessmentLanding: function (assessmentId, assessmentAttemptId, questionCount) {
      if (assessmentAttemptId) {
        this.$refs.MenteeAssessmentLandingModal.getLandingPageContent(assessmentId, assessmentAttemptId);
        this.isAssessmentLandingVisible = true;
      }
      else {
        axios('/desktop/user-assessment-attempts/' + assessmentId + '/' + this.$store.state.user_accountid, {
          method: 'POST',
        })
          .then((resp) => {
            this.$refs.MenteeAssessmentLandingModal.getLandingPageContent(assessmentId, resp.data);
            this.isAssessmentLandingVisible = true;
          })
          .catch(() => {});
      }
    },
    getReloadForms() {
      var userAccountId = '';
      if (this.$store.state.user_accountid) {
        userAccountId = this.$store.state.user_accountid;
      }
      if ((userAccountId)) {
        var formSubmittedUrl = '/my-profile/user/form-lists/' + userAccountId;
      } else {
        if (store.state.roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
          formSubmittedUrl = '/user/submitted-form-lists';
        }
      }

      axios.get(formSubmittedUrl, {})
        .then(response => {
          this.forms = response.data;
        })
        .catch(function () {});
    },
    goToViewForm(formId) {
      if (this.$store.state.user_accountid) {
        var formViewUrl = '/desktop/forms-manager/view-form/' + formId + '/' + this.$store.state.user_accountid;
      } else {
        if (store.state.roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
          formViewUrl = '/forms-manager/view-form/' + formId;
        }
      }

      axios.get(formViewUrl, {
      })
        .then(response => {
          window.open(process.env.API_ENDPOINT + '/web/forms/' + response.data.filepath, '_blank');
        })
        .catch(function (err) {
          console.log("Come here" + err);
        });
    },
    openMenteeEditFormModal(formId, userId) {
      this.$refs.MenteeEditFormModal.getFormData(formId, userId);
      this.isMenteeEditFormVisible = true;
    },
    closeMenteeEditFormModal(flag) {
      if(flag == 1) {
        this.success_message = 'Form edited successfully!';
        this.dismissCountDown = 5;
      }
      this.isMenteeEditFormVisible = false;
    },
    openMenteeFillFormModal(formId) {
      this.$refs.MenteeFillFormModal.getFormData(formId);
      this.isMenteeFillFormVisible = true;
    },
    closeMenteeFillFormModal(flag) {
      if(flag == 1) {
        this.success_message = 'Form successfully completed!';
        this.dismissCountDown = 5;
        this.getReloadForms();
      }
      this.isMenteeFillFormVisible = false;
    },
  },
  created() {
    
  },  
}
</script>

<style scoped>
.checklist-title {
  background-color: #013043;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.checklist-circle {
  border: 1px solid #00acee;
  width: 38px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  font-size: 18px;
  font-weight: bold;
}
@media (max-width: 1199.98px) {
  .checklist-circle {
    width: 28px;
    height: 26px;
    font-size: 13px;
  }
}
.checklist-step-line {
  font-size: 20px; 
  line-height: 14px; 
  color: #00acee;
}
@media (max-width: 1199.98px) {
  .checklist-step-line {
    height: 7px;
  }
  .checklist-box .h6 {
    font-size: .75rem;
  }
}
.step-circle {
  position: absolute;
  /* top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #007bff; */

  border: 1px solid #00acee;
  width: 34px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  font-size: 18px;
  font-weight: bold;
  margin-left: 8px;
}
.step-line {
  position: absolute;
  top: 30px;
  left: 24px;
  width: 0;
  height: 100%;
  border-left: 1px solid #00acee;
}
.step-text {
  margin-left: 56px;
  margin-top: 8px;
}
.step-row {
  min-height: 32px;
}
</style>


// WEBPACK FOOTER //
// src/components/mentor/checklist.vue